import videojs from "@/vendor/videojs/video.es.js";
const Plugin = videojs.getPlugin("plugin");

class HiMarkers extends Plugin {
  constructor(player, options) {
    super(player, options);

    this.on(player, "addMarkers", (event, gameEvents) => {
      let videoDuration = player.duration();
      this.addMarkers(gameEvents, videoDuration);
    });

    this.on(player, "clearMarkers", this.clearMarkers);

    this.on(player, "addPanZoomMarker", this.addPanZoomMarker);

    let tooltipComponent = videojs.getComponent("TimeTooltip");

    //modify tooltip prototype to wrap timestamp in a span so we can hide it later
    tooltipComponent.prototype.write = function(content) {
      if (!this.el_.classList.contains("game-event-hover"))
        this.el_.innerHTML = "<span class='timestamp'>" + content + "</span>";
    };

    function computedStyle(el, prop) {
      if (!el || !prop) {
        return "";
      }

      if (typeof window.getComputedStyle === "function") {
        var computedStyleValue = window.getComputedStyle(el);
        return computedStyleValue
          ? computedStyleValue.getPropertyValue(prop) ||
              computedStyleValue[prop]
          : "";
      }

      return "";
    }

    function getBoundingClientRect(el) {
      if (el && el.getBoundingClientRect && el.parentNode) {
        var rect = el.getBoundingClientRect();
        var result = {};
        ["bottom", "height", "left", "right", "top", "width"].forEach(function(
          k
        ) {
          if (rect[k] !== undefined) {
            result[k] = rect[k];
          }
        });

        if (!result.height) {
          result.height = parseFloat(computedStyle(el, "height"));
        }

        if (!result.width) {
          result.width = parseFloat(computedStyle(el, "width"));
        }

        return result;
      }
    }

    //you can't override the prototype here because of the way videojs is throttling it
    player.childNameIndex_.ControlBar.progressControl.seekBar.mouseTimeDisplay.timeTooltip.update = function update(
      seekBarRect,
      seekBarPoint,
      content
    ) {
      this.write(content);

      var tooltipRect = getBoundingClientRect(this.el_);
      var playerRect = getBoundingClientRect(this.player_.el());
      var seekBarPointPx = seekBarRect.width * seekBarPoint; // do nothing if either rect isn't available
      // for example, if the player isn't in the DOM for testing

      if (!playerRect || !tooltipRect) {
        return;
      } // This is the space left of the `seekBarPoint` available within the bounds
      // of the player. We calculate any gap between the left edge of the player
      // and the left edge of the `SeekBar` and add the number of pixels in the
      // `SeekBar` before hitting the `seekBarPoint`

      var spaceLeftOfPoint =
        seekBarRect.left - playerRect.left + seekBarPointPx; // This is the space right of the `seekBarPoint` available within the bounds
      // of the player. We calculate the number of pixels from the `seekBarPoint`
      // to the right edge of the `SeekBar` and add to that any gap between the
      // right edge of the `SeekBar` and the player.

      var spaceRightOfPoint =
        seekBarRect.width -
        seekBarPointPx +
        (playerRect.right - seekBarRect.right); // This is the number of pixels by which the tooltip will need to be pulled
      // further to the right to center it over the `seekBarPoint`.

      var pullTooltipBy = tooltipRect.width / 2; // Adjust the `pullTooltipBy` distance to the left or right depending on
      // the results of the space calculations above.

      if (spaceLeftOfPoint < pullTooltipBy) {
        pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
      } else if (spaceRightOfPoint < pullTooltipBy) {
        pullTooltipBy = spaceRightOfPoint;
      } // Due to the imprecision of decimal/ratio based calculations and varying
      // rounding behaviors, there are cases where the spacing adjustment is off
      // by a pixel or two. This adds insurance to these calculations.

      if (pullTooltipBy < 0) {
        pullTooltipBy = 0;
      } else if (pullTooltipBy > tooltipRect.width) {
        pullTooltipBy = tooltipRect.width;
      }

      this.el_.style.right = "-" + pullTooltipBy + "px";
    };
  }
  dispose() {
    super.dispose();
  }
  addPanZoomMarker(event, positionObject) {
    //returns position array with dom elements
    let playheadWell = this.player.el().getElementsByClassName("vjs-progress-holder")[0];
    let elem = document.createElement("div");
    const videoDuration = this.player.duration();

    elem.className = "vjs-marker pz-marker";
    elem.pzData = positionObject;
    positionObject.element = elem;

    let position = (positionObject.time / videoDuration) * 100;
    position = 100 * position / 100;

    elem.style.left = position + "%";
    playheadWell.appendChild(elem);
  }
  addMarkers(gameEvents, videoDuration) {
    var iMax = gameEvents.length,
      i,
      playheadWell = document.getElementsByClassName("vjs-progress-holder")[0],
      tooltip = document.getElementsByClassName("vjs-time-tooltip")[0];

    for (i = 0; i < iMax; i++) {
      var elem = document.createElement("div");
      elem.className = "vjs-marker";
      elem.id = "cp" + i;
      elem.setAttribute("data-ge", gameEvents[i].title);

      let position = (gameEvents[i].position / videoDuration) * 100;
      position = Math.round(100 * position) / 100;

      elem.style.left = position + "%";
      elem.addEventListener("mouseover", event => {
        tooltip.classList.add("game-event-hover");
        tooltip.innerHTML =
          "<span class='game-event-text'>" +
          event.target.getAttribute("data-ge") +
          "</span>";
      });
      elem.addEventListener("mouseout", () => {
        tooltip.classList.remove("game-event-hover");
      });
      playheadWell.appendChild(elem);
    }
  }
  clearMarkers() {
    let markers = this.player.el().getElementsByClassName("vjs-marker");
    while(markers.length > 0){
      markers[0].parentNode.removeChild(markers[0]);
    }
  }
}

videojs.registerPlugin("HiMarkers", HiMarkers);
